export default ({ $config }) => {
  if (!$config.noibuSiteId) return

  const script = document.createElement('script')
  script.src = `https://cdn.noibu.com/collect/${$config.noibuSiteId}/noibu.js`
  script.async = true
  document.head.appendChild(script)
}
